import classNames from 'classnames';

import { ProductDetailsDescription } from '../ProductDetailsDescription';
import {
  Product as CharacteristicsProduct,
  Catalog,
  Characteristic,
  ProductDetailsCharacteristics,
} from '../ProductDetailsCharacteristics';

import s from './ProductDetailsProperties.sss';

interface Product extends CharacteristicsProduct {
  description?: string | null,
}

interface Props {
  className?: string,
  product: Product,
  catalog?: Catalog | null,
  characteristics: Characteristic[],
}

export const ProductDetailsProperties: React.FC<Props> = ({
  className,
  product,
  catalog,
  characteristics,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      {!!product.description && (
        <section className={s.description}>
          <ProductDetailsDescription
            description={product.description}
          />
        </section>
      )}

      <section className={s.characteristics}>
        <ProductDetailsCharacteristics
          product={product}
          catalog={catalog}
          characteristics={characteristics}
        />
      </section>
    </div>
  );
};
